import React from "react";
import PropTypes from "prop-types";

const AuthLogo = ({ siteName = "Odoo API" }) => (
  <div className="auth-logo-area">
    <div className="auth-logo-icon">⚡</div>
    <span className="auth-logo-text">{siteName}</span>
  </div>
);

AuthLogo.propTypes = {
  siteName: PropTypes.string
};

export default AuthLogo;
